export const renderSelectedCard = value => {
	if (!value) return '';
	return `${value.card_brand} ${value.last_4}`;
};
